<template>
  <div class="user-summary">
    <p class="summary-label">Así se verá en el listado</p>
    <div class="summary-user">
      <span class="us-avatar summary-avatar">{{ initials }}</span>
      <div class="summary-text">
        <p class="summary-name">{{ user.displayName || "Sin nombre" }}</p>
        <p class="summary-email">{{ user.email || "Sin correo" }}</p>
      </div>
    </div>
    <div class="summary-block">
      <p class="summary-label">Empresa seleccionada</p>
      <p class="summary-value">{{ companyName || "Sin compañía asignada" }}</p>
    </div>
    <div class="summary-block">
      <p class="summary-label">Permisos</p>
      <div v-if="entries.length" class="summary-tags">
        <span
          v-for="entry in entries"
          :key="entry.key"
          class="us-tag"
          :class="'us-tag--' + entry.key"
        >
          {{ entry.label }}
        </span>
      </div>
      <p v-else class="summary-value has-text-grey">Sin permisos</p>
    </div>
    <p v-if="note" class="summary-note">{{ note }}</p>
  </div>
</template>

<script>
import { getInitials, getPermissionEntries } from "../helpers";

export default {
  name: "UserSummary",
  props: {
    user: {
      type: Object,
      required: true,
    },
    companyName: {
      type: String,
      default: "",
    },
    note: {
      type: String,
      default: "",
    },
  },
  computed: {
    initials() {
      return getInitials(this.user);
    },
    entries() {
      return getPermissionEntries(this.user.claims);
    },
  },
};
</script>

<style scoped>
.user-summary {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 22px 24px;
  border: 1px solid #e9e3f2;
  border-radius: 10px;
  background: #fbfafd;
}

.summary-label {
  margin: 0 0 4px;
  font-size: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #7a7a7a;
}

.summary-user {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.summary-avatar {
  width: 44px;
  height: 44px;
  font-size: 15px;
}

.summary-text {
  min-width: 0;
}

.summary-name {
  font-weight: 600;
  color: #363636;
  overflow-wrap: anywhere;
}

.summary-email {
  font-size: 12px;
  color: #7a7a7a;
  overflow-wrap: anywhere;
}

.summary-value {
  font-size: 14px;
  color: #363636;
}

.summary-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.summary-note {
  margin: 0;
  font-size: 13px;
  color: #7a7a7a;
}
</style>



// WEBPACK FOOTER //
// src/components/users/components/UserSummary.vue